import { render, staticRenderFns } from "./iDDUserPortal.vue?vue&type=template&id=0ea06697&scoped=true&"
import script from "./iDDUserPortal.vue?vue&type=script&lang=js&"
export * from "./iDDUserPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea06697",
  null
  
)

export default component.exports